import Label from './Label';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { ValidationError } from './';
import './styles.scss';

const Checkbox = ({
  label,
  labelHidden,
  name,
  onChange,
  required,
  error,
  register,
  ...rest
}) => {
  const getClassNames = () =>
    classNames('form__item', 'form__item--checkbox', `form__item--${name}`);

  return (
    <div className={getClassNames()}>
      <input
        type="checkbox"
        id={name}
        className="form__input"
        aria-required={required}
        aria-invalid={error ? 'true' : 'false'}
        {...register(name)}
        {...rest}
      />
      <Label label={label} name={name} required={required} />
      {error && <ValidationError>{error}</ValidationError>}
    </div>
  );
};

Checkbox.defaultProps = {
  labelHidden: false,
  onChange: null,
};

Checkbox.propTypes = {
  label: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  labelHidden: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  error: PropTypes.node,
};

export default Checkbox;
